import {
  DEFAULT_DURATIONS,
  LocalityGatherDuration
} from '../../locality/Locality';

type RSA = Record<string, number>;

export interface DurationTimer {
  durs: RSA;
  start: number;
}

export interface LocalitySetup {
  gatherDuration: LocalityGatherDuration;
  vals: DurationTimer;
}

export const setupDuration = (): LocalitySetup => {
  const gatherDuration: LocalityGatherDuration = { ...DEFAULT_DURATIONS };
  const durs = (gatherDuration as unknown) as RSA;
  const vals = { durs, start: performance.now() };
  return { gatherDuration, vals };
};

export const addDuration = (args: {
  key: string | number;
  vals: DurationTimer;
}): void => {
  args.vals.durs[args.key] = performance.now() - args.vals.start;
};
